<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 4"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <task-index @id="setId" :active="{ active }"></task-index>
    </el-form>
    <el-form v-if="active === 2">
      <task-edit :id="id" :edit="refresh" :active="{ active }"></task-edit>
    </el-form>
    <el-form v-if="active === 3">
      <task-mytask-view :id="id" :active="{ active }"></task-mytask-view>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "DatatableWithFilter",
  data() {
    return {
      active: 1,
      id: 0,
    };
  },
  methods: {
    setId(id,active) {
      this.active = active;
      this.id = id;
    },
    refresh(id) {
        this.active = id;
    },
    previous() {
        this.active = 1;
    },
  },
};
</script>
